import { connect } from 'react-redux'
import PersonalInfoPane from '../../../components/riders/riderdetails/personalinfo/PersonalInfoPane'
import { IStoreState } from '../../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {}
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalInfoPane)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/PersonalInfoPane.ts